import { render, staticRenderFns } from "./CompanyIcon.vue?vue&type=template&id=5ed0b89e&scoped=true"
var script = {}
import style0 from "./CompanyIcon.vue?vue&type=style&index=0&id=5ed0b89e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed0b89e",
  null
  
)

export default component.exports